var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-layout',{attrs:{"justify-center":""}},[_c('c-progress-overlay',{attrs:{"pending":_vm.pending}}),_c('junit-gantt-chart',{attrs:{"items":_vm.ganttIntervals,"total-items":_vm.meta.total_count,"query":_vm.query,"width":840},on:{"update:query":function($event){_vm.query=$event}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }